import { Button } from '../ui/button';

export function NotFoundPage() {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center text-center px-4">
      <div className="flex flex-col items-center gap-4">
        <span className="text-7xl font-extrabold text-primary-600 dark:text-primary-400">404</span>
        <h1 className="text-3xl md:text-4xl font-bold mb-2">Page Not Found</h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-6 max-w-md">
          Sorry, the page you are looking for does not exist or has been moved.
        </p>
        <Button href="/">Go Home</Button>
      </div>
    </div>
  );
}
